import { useTheme } from "@mui/material";
import { HambergerMenu } from "iconsax-react";

export default function MenuToggle() {
    const theme = useTheme();

    return (
        <HambergerMenu size="24" color={theme.palette.text.primary} variant="TwoTone" />
    );
}